import {pluralize} from "@pg-mono/string-utils";

interface IGenerateRegionsPillLabelOptions {
    hiddenRegionsLabelVariant?: "full" | "compact";
}

export const generateRegionsPillLabels = (regions?: {name: string}[] | null, options?: IGenerateRegionsPillLabelOptions): string[] => {
    if (!regions?.length) {
        return [];
    }

    if (regions.length === 1) {
        return [regions[0].name];
    }

    if (regions.length === 2) {
        return [regions[0].name, regions[1].name];
    }

    const hiddenRegionsCount = regions.length - 1;
    const hiddenRegionsLabel =
        options?.hiddenRegionsLabelVariant === "compact"
            ? `+${hiddenRegionsCount.toString()}`
            : `+${hiddenRegionsCount.toString()} ${pluralize(["lokalizacja", "lokalizacje", "lokalizacji"])(hiddenRegionsCount)}`;

    return [regions[0].name, hiddenRegionsLabel];
};

export const generateRegionsPillLabel = (regions?: {name: string}[] | null, options?: IGenerateRegionsPillLabelOptions): string | null => {
    const labels = generateRegionsPillLabels(regions, options);

    return labels.length > 0 ? labels.join(", ") : null;
};
import {pluralize} from "@pg-mono/string-utils";

interface IGenerateRegionsPillLabelOptions {
    hiddenRegionsLabelVariant?: "full" | "compact";
}

export const generateRegionsPillLabels = (regions?: {name: string}[] | null, options?: IGenerateRegionsPillLabelOptions): string[] => {
    if (!regions?.length) {
        return [];
    }

    if (regions.length === 1) {
        return [regions[0].name];
    }

    if (regions.length === 2) {
        return [regions[0].name, regions[1].name];
    }

    const hiddenRegionsCount = regions.length - 1;
    const hiddenRegionsLabel =
        options?.hiddenRegionsLabelVariant === "compact"
            ? `+${hiddenRegionsCount.toString()}`
            : `+${hiddenRegionsCount.toString()} ${pluralize(["lokalizacja", "lokalizacje", "lokalizacji"])(hiddenRegionsCount)}`;

    return [regions[0].name, hiddenRegionsLabel];
};

export const generateRegionsPillLabel = (regions?: {name: string}[] | null, options?: IGenerateRegionsPillLabelOptions): string | null => {
    const labels = generateRegionsPillLabels(regions, options);

    return labels.length > 0 ? labels.join(", ") : null;
};
